<template>
  <div class="d-flex flex-column ga-3">
    <div>
      <div class="text-body-2 font-weight-semibold ncrm-text-strong">
        {{ $t("ncrm.workflows.nodeSettings.autoSyncTitle") }}
      </div>
      <div class="text-caption text-medium-emphasis mt-1">
        {{ $t("ncrm.workflows.nodeSettings.autoSyncHint") }}
      </div>
    </div>

    <v-switch
      v-model="form.autoSync"
      color="primary"
      hide-details
      :label="form.autoSync
        ? $t('ncrm.workflows.nodeSettings.autoSyncOn')
        : $t('ncrm.workflows.nodeSettings.autoSyncOff')"
    />

    <v-select
      v-if="form.autoSync"
      v-model="form.autoSyncIntervalMinutes"
      :items="intervalOptions"
      item-title="label"
      item-value="value"
      :label="$t('ncrm.workflows.nodeSettings.autoSyncInterval')"
      hide-details="auto"
      :menu-props="menuProps"
    />

    <v-alert
      v-if="form.autoSync"
      type="info"
      density="compact"
      class="text-body-2"
    >
      {{ $t("ncrm.workflows.nodeSettings.autoSyncActiveNote") }}
    </v-alert>
  </div>
</template>

<script>
// Auto-sync worker config for the API Import node. Extracted from
// NcrmWorkflowNodeSettingsDrawer to keep that file within the size policy.
// Mutates the passed `form` object in place ({ autoSync, autoSyncIntervalMinutes }).
export default {
  name: "NcrmWorkflowAutoSyncSettings",
  props: {
    form: { type: Object, required: true },
    intervalOptions: { type: Array, default: () => [] },
    menuProps: { type: Object, default: () => ({}) },
  },
};
</script>
